<template>
  <div class="logo-container">
    <div class="logo">
      <img src="@/assets/logo.svg" alt="">
      <span>Säkerhets-SM 2021 Final</span>
    </div>
  </div>
  <ClockTimeline />
  <div class="button-container">
    <router-link
      v-if="!$store.state.archived"
      class="button"
      tag="button"
      :to="{ name: 'signin' }"
    >
      Registrera dig!
    </router-link>
  </div>
  <div class="content">
    <div>
      <h3>Final</h3>
      <p>
        I slutet av mars tävlade 31 lag i <a href="https://sakerhetssm.se/ssm2021kval/#/scoreboard">kvalet</a>, där 10 lag lyckades komma in i finalen. Nu kommer de kvarstående lagen tävla om förstaplatsen!
      </p>
      <p>
        Endast de 10 lagen som kvalade räknas som inom tävlan och kan få priser i finalen. Alla andra är fortfarande väldigt välkomna att delta i tävlingen, men då utom tävlan.
      </p>
      <h3>Om</h3>
      <p>
        Säkerhets-SM är en nationell Capture The Flag tävling för gymnasiet. Tävlingen fokuserar på problemlösning inom områdena programmering, kryptografi, binär exploatering, reverse engineering, webbsäkerhet och forensik. Uppgifterna varierar från nybörjarvänliga till riktigt kluriga, så även om man aldrig deltagit i en CTF förut så kan man delta. Framför allt så lär man sig mycket av att delta.
      </p>
      <p>
        CTF-tävlingar (Capture The Flag) går ut på att man i början av tävlingen får tillgång till en mängd problem och man visar att man har löst en uppgift genom att skicka in uppgiftens "flagga" till plattformen. Flaggor i den här tävlingen är textsträngar på formen "SSM{...}".
      </p>
    </div>
    <div>
      <h3>Regler</h3>
      <ul>
        <li>Det är förbjudet att diskutera problemlösningar och ledtrådar med andra medans tävlingen pågår.</li>
        <li>Det är förbjudet att vara medlem i flera lag samtidigt.</li>
        <li>Det är förbjudet att attackera CTF-platformen. Detta inkluderar brute-forcing av flaggor.</li>
        <li>Respektera problemservrarna. Skapa inte orimligt stor trafik till problemen. Inga uppgifter kräver att man skickar orimligt mycket data för att få flaggan.</li>
        <li>Det är förbjudet att störa andra personers förmåga att lösa problem.</li>
        <li>Det är förbjudet att ha mer än ett konto på CTF-platformen.</li>
        <li>Arrangörernas beslut är slutgiltiga.</li>
      </ul>
      <h3>Discord</h3>
      <p>
        Gå med i Kodsports <a href="https://discord.gg/m6pcEYp">Discordserver</a> för att diskutera tävlingen med andra i #säkerhetssm kanalen! Om du inte har några lagkamrater eller om ditt lag inte är fullt kan man också skicka meddelande i #leta-lag kanalen för att hitta folk att spela med. I discorden finns också alla admins och problemskapare i fall man behöver ta kontakt med dem.
      </p>
    </div>
  </div>
  <div class="centeredcontent">
    <h3>Priser</h3>
    <p>Topplagen inom tävlan vinner priser! Dessa priser är per lag:</p>
    <ul>
      <li>Första plats: 3000kr presentkort hos webhallen</li>
      <li>Andra plats: 1800kr presentkort hos webhallen</li>
      <li>Tredje plats: 1500kr presentkort hos webhallen</li>
      <li>Fjärde plats: 1200kr presentkort hos webhallen</li>
      <li>Femte plats: 900kr presentkort hos webhallen</li>
    </ul>
    <p>
      Utöver detta vinner de bästa två lagen en gemensam plats till <a href="https://midnightsunctf.se/">Midnight Sun CTF</a> finalen! Om ett lag redan har kvalat går möjligheten till nästa lag. I fall det gemensamma laget inte blir exakt 6 medlemmar får de själva välja vem mer de vill ta med.
    </p>
  </div>
  <h3>Huvudsponsor</h3>
  <div class="mainsponsorcontainer">
    <a href="https://www.sentor.se/">
      <img class="mainsponsor" src="@/assets/sponsors/sentor.png">
    </a>
  </div>
  <h3>Sponsorer</h3>
  <div class="sponsorcontainer">
    <a href="https://www.microaalabs.se/">
      <img class="sponsor" src="@/assets/sponsors/microaa.png">
    </a>
    <a href="https://www.msab.com">
      <img class="sponsor" src="@/assets/sponsors/msab.png">
    </a>
    <a href="https://jobb.orangecyberdefense.com/">
      <img class="sponsor" src="@/assets/sponsors/orange.png">
    </a>
    <a href="https://www.venor.se/">
      <img class="sponsor" src="@/assets/sponsors/venor.png">
    </a>
  </div>
  <p style="text-align: center">
    Infra sponsored by <a href="https://g.co/cloud">g.co/cloud</a>
  </p>
</template>

<script>
import ClockTimeline from '@/components/ClockTimeline.vue'

export default {
    name: 'Home',
    components: {
        ClockTimeline,
    },
}
</script>

<style lang="scss" scoped>
.logo-container {
  .logo {
    margin-left: auto;
    margin-right: auto;
    position: relative;
    text-align: center;
    max-width: 50rem;

    span {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      font-size: 2rem;
      background-color: rgba(0,44,54, 0.4);
      padding: 0 1rem;
      word-wrap: normal;
    }
  }
}

h1, h3 {
  text-align: center;
}

p {
  padding: 0 10px 0 10px;
}

.button-container {
  margin-top: 2rem;
  text-align: center;
}

.button {
  padding: 0.6rem 1rem;
  font-size: 2rem;
  color: #ffab1c;
}

.content {
  display: grid;
  grid-template-columns: 50% 50%;
  padding-top: 3rem;
}

.centeredcontent {
  width: 50%;
  margin: 0 auto;
}

.mainsponsorcontainer {
  text-align: center;
}

.mainsponsor {
  max-width: 100%;
  max-height: 150px;
  padding-bottom: 1rem;
}

.sponsorcontainer {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}

.sponsor {
  max-width: 90%;
  max-height: 100px;
  margin: 1rem 1rem;
}

@media only screen and (max-width: 990px) {
  .content {
    display: block;
  }

  .centeredcontent {
    width: auto;
  }
}
</style>
